import _JSON$stringify from "@babel/runtime-corejs2/core-js/json/stringify";
import _Object$defineProperty from "@babel/runtime-corejs2/core-js/object/define-property";
import sendLog from './sendLog';
import AES from '@ali/aes-tracker';

function hookMtop() {
  if (!window.lib) {
    window.lib = {};
  } // 处理返回信息
  // 当接口直接404、500时，不会走到这个中间键


  function detectMtopError(next) {
    var options = this.options;
    var params = this.params;
    var begin = new Date().getTime();
    return next().then(function () {
      var ret = options.retJson.ret;
      var duration = new Date().getTime() - begin;

      if (ret instanceof Array) {
        ret = ret.join(',');
      }

      var config = AES.getConfig('plugin_api') || {}; // 用户自定义解析规则

      var customize = {};

      if (typeof config.parseResponse === 'function') {
        try {
          customize = config.parseResponse(options.retJson, '', {
            type: 'mtop',
            params: params.data,
            url: params.api
          }) || {};
        } catch (e) {
          console && console.error && console.error(e);
        }

        ;
      }

      var isFail = customize.success === undefined ? ret.indexOf('SUCCESS') === -1 : !customize.success;

      if (isFail || !config.disable_send_on_success) {
        var eagleeId; // 因为在接口404、500等异常时不会走到中间键，这里默认200

        var status = options.retJson.code || 200;
        var responseHeaders = options.retJson.responseHeaders;

        if (typeof responseHeaders === 'string') {
          //鹰眼ID
          var matchEagleeId = responseHeaders.match(/(x-eagleeye-id|eagleeye-traceid):\s*([a-z0-9]+)/);

          if (matchEagleeId) {
            eagleeId = matchEagleeId[2];
          } // http status


          var matchStatus = responseHeaders.match(/status:\s*(\d+)/);

          if (matchStatus) {
            status = matchStatus[1];
          }
        }

        var code, msg;

        if (ret) {
          var retArr = ret.split('::');
          code = retArr[0];
          msg = retArr[1];
        }

        sendLog({
          url: params.api,
          success: !isFail,
          // lib-mtop的请求类型，GET or POST。lib-mtop默认以GET方式发送请求：https://code.aone.alibaba-inc.com/mtb/lib-mtop
          method: params.type || 'GET',
          msg: customize.msg || msg,
          status: status,
          code: customize.code || code,
          duration: duration,
          traceId: eagleeId,
          params: params.data,
          response: _JSON$stringify(options.retJson),
          rtype: 'mtop'
        });
      }
    });
  }

  if (lib.mtop) {
    if (lib.mtop.middlewares) {
      lib.mtop.middlewares.push(detectMtopError);
    }
  } else {
    var mtop;

    _Object$defineProperty(lib, 'mtop', {
      configurable: true,
      set: function set(v) {
        mtop = v;

        if (mtop.middlewares) {
          if (mtop.middlewares.indexOf(detectMtopError) === -1) {
            mtop.middlewares.push(detectMtopError);
          }
        } else {
          var middlewares;

          _Object$defineProperty(mtop, 'middlewares', {
            configurable: true,
            set: function set(v) {
              middlewares = v;

              if (middlewares.indexOf(detectMtopError) === -1) {
                middlewares.push(detectMtopError);
              }
            },
            get: function get() {
              return middlewares;
            }
          });
        }
      },
      get: function get() {
        return mtop;
      }
    });
  }
}

;
export default hookMtop;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ali_aes-tracker-plugin-api@1.1.12@@ali/aes-tracker-plugin-api/es/libs/hookMtop.js
// module id = null
// module chunks = 